import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerSW } from "./lib/pwa.ts";
import { ThemeProvider } from "./context/ThemeContext.tsx";

// Initialize PWA service worker
// This handles the PWA update prompts and registration
registerSW();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
